import React from 'react';
import Card from './components/card';
import Fade from 'react-reveal/Fade'
import './styles/main.css'

export default function main() {
  return (
    <div className="pretty-body">
      <iframe
        src="/prettygirl.svg"
        className="bg-svg"
        title="background"
      />
      <Fade top>
        <h1 style={{"color": "green", "fontSize": "4em"}}>Hi there Pretty Girl</h1>
        <Card />
      </Fade>
    </div>
  );
}